<template>
	<div id="app">
		<el-dialog
			title="后台任务"
			:visible.sync="taskVisible"
			width="100%"
            :modal="false"
            :close-on-click-modal = "false"
            custom-class="messageTask"
            :modal-append-to-body='false'
            :append-to-body="false"
            :before-close="closeHandle"
			>
			<ul class="taskCenter">
				<li v-for="item in newTaskData" :key="item.id">
                    <img :src="require('@/assets/images/excel.png')" class="excel">
                    <div class="caption">
                        <div>
                            <span class="title"> {{item.name}} </span>
                            <span class="des" v-if="item.state === 'running'" > 耗时:  {{item.time || ''}} </span>
                            <span class="des" v-else> 时间: {{item.createTime | dataFilter}} </span>
                        </div>
                        <div> 
                            <span class="stateStyle" v-if="item.state === 'complete'">{{item.message}}</span>
                            <span  class="stateStyle"  v-else-if="item.state === 'running'" style="color: #dcba56"> {{item.message}} </span>
                            <span  class="stateStyle"  style="color:#d15053; font-size:11px;" v-else> {{item.message}} </span>
                        </div>
                    </div>
                    <div class="state">
                        <div v-if="item.state === 'running'" style="display: flex; ">
                            <div class="cancelDown" @click="cancelDownloadHandle(item)">取消下载</div>
                            <img :src="require('@/assets/images/waiting.svg')"  class="excel">
                        </div>
                        <template v-else>
                            <el-tooltip v-if="item.state === 'complete'"  :content="`下载次数: ${item.downloadTimes}`" placement="left-start" effect="light">
                                <span class="down" @click="downLoadeHandle(item)">下载</span>
                            </el-tooltip>
                            <span v-else-if="item.state === 'cancelled'" style="color: #d15053;">已取消</span>
                            <span v-else style="color:#d15053"> 失败 </span>
                        </template>
                    </div>
                </li>
			</ul>
            <el-button style="margin:15px auto; display:block;"  @click="$emit('moreHandle')"  size="mini">查看更多</el-button>
		</el-dialog>
	</div>
</template>

<script>
import downloadMixin from './mixin/index';
import moment from 'moment';
export default {
	name: 'MessageTask',
	components: {
	},
    mixins: [downloadMixin],
	props: {
		taskVisible: {  
            type: Boolean,
            default: false,
        },
        taskData:{
            type: Array,
            default: () => {
                return [];
            },
        },
	},
	data() {
		return {
            newTaskData:[],
		}
	},
    watch:{
        taskData:{
            immediate:true,
            deep:true,
            handler(val){
                if(val){
                    this.newTaskData = val
                }
            }
        }
    },
    filters:{
        dataFilter(val){
            return moment(val).format('YYYY-MM-DD HH:mm:ss')
        }
    },
	methods: {
        closeHandle(){
			this.$emit('close');
		},
	},
	mounted() {},
	created() {},
}
</script>
<style lang="scss"  scoped>
::v-deep .el-dialog__header{
    padding: 0 15px;
    height: 45px;
    line-height: 45px;
}
::v-deep .el-dialog__body{
    padding:0;
}
::v-deep .el-dialog__wrapper {
    position: fixed;
    width: 480px;
    height: 505px;
    top: 85px;
    right: 0;
    bottom: inherit;
    left: inherit;
    overflow: auto;
    margin: 0;
    box-shadow: 0 0 20px rgba(34, 36, 38, 0.3) ;
    background: #fff;
}
.taskCenter{
    height: 400px;
    border-top:1px solid rgba(34, 36, 38, 0.15);
    overflow-y: scroll;
    .el-icon-folder{
        color: green;
    }
    li{
        padding:10px;
        display: flex;
        flex: row;
        justify-items: center;
        align-items: center;
        font-size: 12px;
        border-bottom:1px solid rgba(34, 36, 38, 0.15);
        .down{
            cursor: pointer;
            color: #0869bd;
        }
        .cancelDown{
            line-height: 28px;
            white-space: nowrap;
            display: inline-block;
            cursor: pointer;
            color: #fff;
            background: #0869bd;
            padding: 0px 6px;
            border-radius: 4px;
        }
        .caption{
            flex: 1;
            .title{
                max-width: 220px;
                overflow: hidden;
                text-overflow: ellipsis;
                /* 将对象作为弹性伸缩盒子模型显示 */
                display: -webkit-box;
                /* 限制在一个块元素显示的文本的行数 */
                /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
                -webkit-line-clamp: 1;
                /* 设置或检索伸缩盒对象的子元素的排列方式 */
                -webkit-box-orient: vertical;
                display: inline-block;
                color: rgba(0, 0, 0, 0.87);
                padding-right:20px;
            }
            .des{
                color: #999;
            }
            .stateStyle{
                width: 330px;
                 display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                text-overflow: ellipsis;

            }
        }
        .state{
            min-width: 60px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .el-icon-loading{
                width: 14px;
                font-size: 14px;
                color: green;
            }
        }
        .excel{
            width: 26px;
            height: 28px;
            margin:0 5px;
        }   
    }
    .viewMore{
        font-size: 12px;
        
    }
}

</style>
<style>
.messageTask{
    position: absolute;
    right: 0 !important;
    top:0 !important;
    margin-top: 0 !important;
}
.el-tooltip__popper.is-light {
    background: #fff !important;
    border: 1px solid #999 !important;
    color: #666 ;
}

</style>

